
import TableList from "@components/templates/tablelist";
// import { HttpProductList } from '@/service/inbound';
import { HttpPlanBillErpSku } from '@/service/destory'
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
        };
    },
    methods: {
        ajaxRequest: HttpPlanBillErpSku,
        interceptRequest(params) {
            // params.search.EQ_status = 0
            params.search.EQ_enable = 1
            // delete params.rows
            // delete params.page
            return params
        },
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            },
            {
                label: "名称",
                tag: 'vInput',
                key: 'CN_productName',
                show: true,
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'sku'
            }, {
                title: "名称",
                key: 'name',
                render: (h, { row }) => {
                    return (
                        <div>
                            {row.productNameEn}({row.productName})
                        </div>
                    )
                }
            }, {
                title: "可用库存",
                key: 'inventoryAvailable'
            },
            {
                title: "操作",
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, "选择")
                }
            }]
        }
    }

};
